var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#075494;}\r\n\t.st2{fill:none;stroke:#075494;stroke-width:10;stroke-miterlimit:10;}\r\n\t.st3{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7,78.7c13.5,26.5,35.2,48.1,61.6,61.6l20.6-20.6c2.5-2.5,6.3-3.4,9.5-2.2c10.5,3.5,21.8,5.3,33.4,5.3 c5.1,0,9.4,4.2,9.4,9.4v32.6c0,5.1-4.2,9.4-9.4,9.4c-87.8,0-159-71.2-159-159c0-5.1,4.2-9.4,9.4-9.4h32.7c5.1,0,9.4,4.2,9.4,9.4 c0,11.7,1.9,22.9,5.3,33.4c1,3.3,0.3,6.9-2.3,9.5L39.7,78.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.49559dc2.svg";
export { ForwardRef as ReactComponent };